var _ellipse, _path, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooticon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 283,
    height: 312,
    viewBox: "0 0 283 312",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.5,
    cy: 31,
    rx: 23.5,
    ry: 31,
    fill: "url(#paint0_linear_400_131)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.5002 194.5C133 257 122.308 312 81.9916 312C4.49815 306.5 43.9981 229.5 4.49815 172C-2.50008 106 41.6748 77 81.9916 77C122.308 77 152 97 93.5002 194.5Z",
    fill: "url(#paint1_linear_400_131)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20,
    cy: 66.5,
    rx: 8,
    ry: 10.5,
    fill: "url(#paint2_linear_400_131)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40,
    cy: 46.5,
    rx: 12,
    ry: 15.5,
    fill: "url(#paint3_linear_400_131)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.5,
    cy: 31,
    rx: 14.5,
    ry: 19,
    fill: "url(#paint4_linear_400_131)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6,
    cy: 90.5,
    rx: 6,
    ry: 8.5,
    fill: "url(#paint5_linear_400_131)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_400_131",
    x1: 140,
    y1: -23.5,
    x2: 28.5,
    y2: 332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_400_131",
    x1: 31,
    y1: 213,
    x2: -432.321,
    y2: 1399.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_400_131",
    x1: 28,
    y1: 48.0403,
    x2: -9.60965,
    y2: 168.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_400_131",
    x1: 52,
    y1: 19.25,
    x2: -2.79088,
    y2: 197.659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_400_131",
    x1: 87,
    y1: -2.40323,
    x2: 19.0364,
    y2: 215.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_400_131",
    x1: 12,
    y1: 75.5565,
    x2: -20.3879,
    y2: 171.712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_400_131",
    x1: 212,
    y1: 121,
    x2: 112,
    y2: 318.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#373737",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_400_131",
    x1: 212,
    y1: 121,
    x2: 15,
    y2: 433.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#373737"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_400_131",
    x1: 212,
    y1: 21,
    x2: -2.49999,
    y2: 525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#373737",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooticon2);
export default __webpack_public_path__ + "static/media/FOOT ICON2.569a59b271641bf362c5a6e1bc1c37ec.svg";
export { ForwardRef as ReactComponent };